import { render, staticRenderFns } from "./CommissionPackSection.vue?vue&type=template&id=707c9cc4&scoped=true"
import script from "./CommissionPackSection.vue?vue&type=script&lang=js"
export * from "./CommissionPackSection.vue?vue&type=script&lang=js"
import style0 from "./CommissionPackSection.vue?vue&type=style&index=0&id=707c9cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707c9cc4",
  null
  
)

export default component.exports